import { render, staticRenderFns } from "./ProgramacionRegaliasIndex.vue?vue&type=template&id=0607fe42"
import script from "./ProgramacionRegaliasIndex.vue?vue&type=script&lang=js"
export * from "./ProgramacionRegaliasIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports